/**
 * 路由 — 主布局下使用 `DynamicAdminPage` 按路径解析具体页面；未实现的菜单见占位页。
 */
import { Navigate, Route, Routes } from 'react-router-dom';
import { ReactElement } from 'react';
import { useAuthStore } from '../store/auth';
import { MainLayout } from '../layout/MainLayout';
import { Login } from '../pages/Login';
import { DynamicAdminPage } from './DynamicAdminPage';

function RequireAuth({ children }: { children: ReactElement }) {
  const profile = useAuthStore((s) => s.profile);
  const accessToken = useAuthStore((s) => s.accessToken);
  if (!accessToken || !profile) return <Navigate to="/login" replace />;
  return children;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <MainLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/platform/dashboard" replace />} />
        <Route path="*" element={<DynamicAdminPage />} />
      </Route>
    </Routes>
  );
}
